<template>
  <div class="cw-widget">
    <button @click="this.toggleWidget" class="cw-widget-button-holder" v-if="this.showWidgetButton" :style="this.cssVars"
      :class="[this.openerTypeName, { 'slide-in': !this.showWidget, 'showFullScreen': this.showFullScreen, 'slide-out': this.showWidget, 'use-custom-padding': this.useCustomOpenerPadding }]">

      <div class="cw-icon" :class="{ 'has-bg': this.openerHasBackgroundImage }">
        <svg style="margin:5px;" v-if="this.showTickOpenerLogo" data-v-06fb36cc="" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="logo">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M1 0H9H11C13.2091 0 15 1.79086 15 4V6V24H13C10.7909 24 9 22.2091 9 20V6H5C2.79086 6 1 4.20914 1 2V0ZM19 0H17V6H23V4C23 1.79086 21.2091 0 19 0Z"></path>
        </svg>


      </div>

      <div class="cw-title" v-if="this.openerTitle"> {{ this.openerTitle }}</div>
    </button>


    <div v-if="this.showWidget" class="cw-widget-holder" :style="this.cssVars"
      :class="{ 'showFullScreen': this.showFullScreen, 'slide-in': this.showWidget, 'slide-out': !this.showWidget, 'useWidth': this.useWidth, 'forceShowWidget': this.forceShowWidget }">

      <div class="cw-header-holder" :class="{ 'use-custom-padding': this.useCustomHeaderPadding }">
        <button v-show="!this.showLobby" class="cw-header-toggle-notifications" :class="{ 'on': this.notifyIncomingMessages }" @click="this.toggleNotifications">
          <svg v-if="this.notifyIncomingMessages" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="feather feather-volume-2">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
          </svg>

          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-volume-x">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
            <line x1="23" y1="9" x2="17" y2="15"></line>
            <line x1="17" y1="9" x2="23" y2="15"></line>
          </svg>
        </button>
        <span class="cw-header-title">{{ this.generalTitle }}</span>
        <button class="cw-header-toggle-widget" @click="this.toggleWidget"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" fill="none" viewBox="0 0 16 16">
            <path id="svg_1" opacity="0.6" d="m4.20787,12.70787l8.5,0l0,-8.5m-10,-1.5l10,10" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <FileDropZone @dropped="this.addFiles" :clickToSelect="false">
        <div class="cw-widget-content" :class="{ 'use-custom-padding': this.useCustomPadding }">
          <template v-if="this.showLobby">
            <Lobby @onAction="this.onLobbyAction" :settings="this.widgetSettings">
              <slot />
            </Lobby>
          </template>

          <div v-else class="cw-messaging-holder">
            <Message :showAvatar="this.showAvatar" :useCustomActionPadding="this.useCustomActionPadding" :useCustomInboundPadding="this.useCustomInboundMessagePadding"
              :useCustomOutboundPadding="this.useCustomOutboundMessagePadding" :message="message" :positionAllMessagesLeft="this.positionAllMessagesLeft"
              :sameSenderAsBefore="this.isSameSenderAsBefore(message, index)" v-for="(message, index) in this.messages" :key="message.messageId" />
            <div class="cw-uploads">
              <TickFileUploadProgress :file="file" v-for="(file) in this.uploadingFiles" :key="file.id" />
            </div>
          </div>
          <div class="cw-typingindicator-holder">

            <TypingIndicator :users="this.typingUsers" :communicators="this.typingCommunicators" />
          </div>


          <div class="cw-communication-holder" :class="{ 'use-custom-padding': this.useCustomMessageBoxPadding }">

            <div class="cw-message-holder">
              <TickTextarea class="cw-message-draft-text" @enter="this.onHitEnter" v-model="this.draft.message" />
            </div>
            <div class="cw-actions-holder">

              <label for="tickwidget-fileUpload" v-if="this.fileUploadsAllowed">
                <div class="cw-general-button"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" class="feather feather-paperclip">
                    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                  </svg></div>
              </label>

              <button class="cw-general-button" @pointerdown.prevent @click.stop.prevent="this.send">
                <svg data-v-344e9f68="" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M8 12.6668V3.3335"></path>
                  <path d="M3.33325 8.00016L7.99992 3.3335L12.6666 8.00016"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </FileDropZone>
    </div>
  </div>
</template>

<script lang="ts">
import FileDropZone from "@/components/atoms/FileDropZone.ce.vue";
import TickFileUploadProgress from "@/components/atoms/TickFileUploadProgress.ce.vue";
import TickTextarea from "@/components/atoms/TickTextarea.ce.vue";
import { getRandomInt } from "@/helpers/randomHelper";
import generateBorderRadius, { generateDropShadow, generatePadding, generateStylingProperties } from "@/helpers/styleHelper";
import { debug, error } from "@/log";
import { watchToken } from "@/services/Server";
import useAppStore from "@/store/app";
import useFilesStore from "@/store/files";
import useViewstateStore, { InterfaceStateType } from "@/store/viewstate";
import { BasicTicketEvent, ChatWidgetActionRequest, ChatWidgetPublicSettingsData, OpenerTypeEnum, OpeningHoursItem, TypingCommunicatorData, TypingUserData } from "@/TickApi";
import { Component, Prop, Watch } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import Lobby from "./Lobby.ce.vue";
import Message from "./Message.ce.vue";
import TypingIndicator from "@/components/atoms/TypingIndicator.ce.vue";
import { deviceIsMobile } from "@/helpers/deviceHelper";

export enum widgetViewState {
  opener = "opener",
  lobby = "lobby",
  messages = "messages"
}

export enum ChatWidgetEventType {
  toggle = "toggle",
  open = "open",
  basicEvent = "basicevent",
  addMessage = "message",
}

export class ChatWidgetEvent {
  cwtoken?: string; // optional for only allowing the event for one chat widget when having multiple on the same page 
  type: ChatWidgetEventType;
  data: BasicTicketEvent | SendMessageFromExternalRequest
}

export class SendMessageFromExternalRequest {
  message: string;
}

interface messageMetaDataHook {
  (message: string): unknown;
}

export interface PublicTickInstance {
  addWidgetToPage(cwToken: string): HTMLElement;
  addEvent(event: ChatWidgetEvent,): void;
  setMessageMetaDataHook(f: messageMetaDataHook): void;

}

@Component({
  emits: [],
  components: { TickTextarea, Message, FileDropZone, TickFileUploadProgress, Lobby, TypingIndicator },
})
export default class TickChatWidget extends Vue {
  // props are delivered via attributes and therefore must be lowercase
  @Prop() private cwtoken!: string;
  @Prop({ default: null }) private forcerefresh?: string;
  @Prop({ default: null }) private settings?: ChatWidgetPublicSettingsData;
  @Prop({ default: null }) private previewmessages?: ChatWidgetActionRequest[];
  @Prop({ default: null }) private chatwidgetid?: string;
  @Prop({ default: null }) private viewstate?: string;


  private ignoreForcedViewstate = false;
  private uploadGroup = "widget";
  private questPollerTimer: any = null;
  private sendMessageMetaDataHook = null;

  private setSendMessageMetaDataHook(f: messageMetaDataHook) {
    debug(`Chat widget metadata hook added`);
    this.sendMessageMetaDataHook = f;
  }


  private get showFullScreen(): boolean {
    return useAppStore().deviceShowFullScreen;
  }

  private get typingUsers(): TypingUserData[] {
    return this.draft.typingUsers || [];


    // return [{
    //   userId: "",
    //   name: "test",
    // },
    // {
    //   userId: "",
    //   name: "test",
    // }]
  }

  private get typingCommunicators(): TypingCommunicatorData[] {
    return this.draft.typingCommunicators || [];
    //return []
  }


  private get widgetSettings() {
    let set = this.settings;

    if (set && typeof (set) == 'string') {
      set = JSON.parse(set);
    }

    return set || useAppStore().cwSettings;
  }


  private get channelIsOpen() {
    var settings = this.widgetSettings;

    //TESTING
    // settings.openingHours.useOpeningHours = true;
    // settings.openingHours.friday = {
    //   allDay: false,
    //   fromUtcHours: 0,
    //   fromUtcMinutes: 0,
    //   toUtcHours: 8,
    //   toUtcMinutes:0,

    // }

    if (!settings?.openingHours?.useOpeningHours) { return true; }

    const weekday = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
    const d = new Date();
    let day = weekday[d.getUTCDay()];

    let hour = d.getUTCHours();
    let minutes = d.getUTCMinutes();

    const daySettings = settings.openingHours[day] as OpeningHoursItem;
    if (daySettings && !daySettings.allDay) {
      // before opening hours
      if (hour < daySettings.fromUtcHours || (hour <= daySettings.fromUtcHours && minutes < daySettings.fromUtcMinutes)) { return false; }

      // after opening hours
      if (hour > daySettings.toUtcMinutes || (hour >= daySettings.toUtcMinutes && minutes > daySettings.toUtcMinutes)) { return false; }

      return true;
    } else {
      // no settings or all day
      return true;
    }

  }

  private get notifyIncomingMessages() {
    return useAppStore().notifyIncomingMessages;
  }

  private toggleNotifications() {
    useAppStore().notifyIncomingMessages = !useAppStore().notifyIncomingMessages
  }

  private get isPreview() {
    return useAppStore().isPreview;
  }

  private get forceOpener(): boolean {
    if (this.ignoreForcedViewstate) { return false; }
    return this.viewstate && this?.viewstate == widgetViewState.opener;
  }
  private get forceLobby(): boolean {
    if (this.ignoreForcedViewstate) { return false; }
    return this.viewstate && this.viewstate == widgetViewState.lobby;
  }
  private get forceMessages(): boolean {
    if (this.ignoreForcedViewstate) { return false; }
    return this.viewstate && this.viewstate == widgetViewState.messages;
  }

  private get forceShowWidget(): boolean {
    return this.forceLobby || this.forceMessages;
  }




  private get uploadingFiles() {
    return useFilesStore().uploadableFiles.filter(p => p.group == this.uploadGroup) || [];
  }

  private get showLobby() {
    return this.forceLobby || this.messages.length == 0;
  }

  private get showWidget() {
    if (this.forceOpener) { return false; }
    return this.forceShowWidget || (this.tickAvailable && useViewstateStore().has(InterfaceStateType.ShowWidget));
  }

  private toggleWidget(newState?: boolean | PointerEvent) {
    newState = typeof (newState) == 'boolean' ? newState : undefined;

    if (!this.isPreview) {
      this.startConnection();
    }

    if (newState == undefined) {
      useViewstateStore().toggle(InterfaceStateType.ShowWidget);
    } else {
      useViewstateStore().set({
        key: InterfaceStateType.ShowWidget,
        state: newState,
      });
    }
  }

  private startConnection() {
    useAppStore().use();
  }

  private get showWidgetButton() {
    return this.forceOpener || (this.tickAvailable && !this.showWidget && this.channelIsOpen);
  }

  private get tickAvailable() {
    return useAppStore().ready;
  }

  private get publicTickInstance(): PublicTickInstance {
    return {
      addEvent: this.onExternalChatWidgetEvent,
      addWidgetToPage: this.addChatWidgetAsHtmlElement,
      setMessageMetaDataHook: this.setSendMessageMetaDataHook,
    }
  }

  private addChatWidgetAsHtmlElement(cwToken: string): HTMLElement {
    var newWidget = document.createElement('tick-chatwidget');
    newWidget.setAttribute("cwToken", cwToken);

    document.body.appendChild(newWidget);
    return newWidget;
  }

  mounted() {
    const cwToken = this.cwtoken || null;
    if (!cwToken) {
      error("[TICK:ERROR] No cwtoken attribute provided, please add the tag like <tick-chatwidget cwtoken='CW:PasteFromChannelSettings' ></tick-chatwidget>")
    }

    (document as any).TickChatWidget = this.publicTickInstance;
    //useAppStore().cwToken = cwToken;

    if (this.chatwidgetid) {
      useAppStore().chatWidgetId = this.chatwidgetid;
    }
    const fresh = (this.forcerefresh == "true") ? true : false;
    watchToken(cwToken, fresh);
    debug(`Widget element created with cwtoken: ${cwToken}`)

    if (this.forceShowWidget) {
      this.toggleWidget();
    }

    if (this.showWidget || this.messages.length >= 1) {
      this.startConnection();
    }

  }

  private beforeUnmount() {
    clearTimeout(this.questPollerTimer);
  }

  private beforeMount() {
    this.startPoller();
  }


  private onExternalChatWidgetEvent(event?: ChatWidgetEvent) {
    if (!event) {
      this.toggleWidget();
      return;
    }

    switch (event.type) {
      case ChatWidgetEventType.addMessage:
        this.toggleWidget(true);
        useAppStore().send(null, null, typeof (event.data) == 'string'
          ? event.data
          : (event.data as SendMessageFromExternalRequest).message);

        break;
      case ChatWidgetEventType.basicEvent:
        useAppStore().sendBasicEvent(event.data as BasicTicketEvent)
        break;

      case ChatWidgetEventType.open:
        this.toggleWidget(true);
        break;
      case ChatWidgetEventType.toggle:
      default:
        this.toggleWidget();
        break;
    }
  }

  private startPoller() {
    // Choose random interval because when connection drops ALL connected clients will otherwise poll at the exact same timing which will break the backend
    const randomInterval = getRandomInt(5000, 15000);
    this.questPollerTimer = setTimeout(() => {
      useAppStore().pollUpdates();
      this.startPoller();
    }, randomInterval);
  }



  private get draft() {
    return useAppStore().draft;
  }



  private tryGetMetaDataViaHook(): object {
    try {

      if (!this.sendMessageMetaDataHook) { return null; }

      let metadata = this.sendMessageMetaDataHook();
      if (typeof (metadata) == 'function') { metadata = metadata(); }
      if (typeof (metadata) == 'object') { return metadata }

      if (typeof (metadata) == 'string') {
        // check if json
        try {
          return JSON.parse(metadata);
        } catch (e) {
          return {
            no_label: metadata
          };
        }
      }


      if (typeof (metadata) == 'boolean') {
        return {
          no_label: metadata
        }
      }

      if (typeof (metadata) == 'number' || typeof (metadata) == 'bigint') {
        return {
          no_label: metadata
        }
      }

      if (Array.isArray(metadata)) {
        return {
          no_label: metadata
        }
      }

      if (metadata) { return metadata; }
    } catch (error) {
      debug(`The MetaData hook experienced an error, the message is still sent but without the additional information.`);
      console.error(error);
    }
    return null;

  }

  private onLobbyAction(actionId: string) {
    const metaData = this.tryGetMetaDataViaHook();
    useAppStore().send(metaData, actionId);
  }

  private onHitEnter() {
    this.send();
  }

  private send() {
    const metaData = this.tryGetMetaDataViaHook();
    useAppStore().send(metaData);
  }

  private isSameSenderAsBefore(message: ChatWidgetActionRequest, index: number) {
    if (index == this.messages.length) { return false; }

    const before = this.messages[index + 1];

    return before
      && message.direction == before.direction
      && message?.senderInfo?.senderId == before?.senderInfo?.senderId;

    // return before
    //   && message.direction == before.direction
    //   && (message.senderInfo?.name == before.senderInfo?.name);
  }


  private get messages() {
    let previewMessages = this.previewmessages;

    if (previewMessages && typeof (previewMessages) == 'string') {
      previewMessages = JSON.parse(previewMessages);
    }


    const items = (previewMessages || useAppStore().messages);

    var response = items.sort(({ sentDateAsTick: a }, { sentDateAsTick: b }) => a - b);
    return response.reverse();
  }


  private addFiles(newFiles: []) {
    if (!this.fileUploadsAllowed) { return; }
    useFilesStore().startUpload(this.uploadGroup, newFiles);
  }

  private get showTickOpenerLogo(): boolean {
    return this.openerHasBackgroundImage == false && this.openerTitle.length < 1;
  }

  // private get calculatedSettings() {
  //   const givenSettings = this.settings;
  //   const serverSettings = useAppStore().cwSettings
  //   console.log(this.widgetSettings);

  //   return givenSettings || serverSettings;
  // }

  private get openerBackgroundUrl() {
    if (!this.tickAvailable) { return "" }

    return this.widgetSettings?.opener?.backgroundImageFileUrl || "";
  }

  private get openerType(): OpenerTypeEnum {
    if (!this.tickAvailable) { return OpenerTypeEnum.Square }
    const settings = this.widgetSettings;

    return settings?.opener?.type || OpenerTypeEnum.Square;
  }
  private get openerTitle(): string {
    //return "Chat";
    if (!this.tickAvailable) { return ""; }

    return this.widgetSettings?.opener?.title || "";
  }

  private get openerHasBackgroundImage(): boolean {
    if (!this.tickAvailable) { return false; }
    return this.widgetSettings?.opener?.styling?.showBackground && this.widgetSettings?.opener?.backgroundImageFileUrl?.length > 0;
  }

  private get openerTypeName(): string {
    // return "landscape";

    const type = this.openerType;

    switch (type) {
      case OpenerTypeEnum.Square: return 'square';
      case OpenerTypeEnum.Landscape: return 'landscape';
      default: return 'square';
    }
  }


  private get generalTitle() {
    if (!this.tickAvailable) { return "" }
    return this.widgetSettings.title || "Powered by Tick";
  }

  private get fileUploadsAllowed(): boolean {
    if (!this.tickAvailable) { return false }

    return this.widgetSettings?.allowFileUploads || false;
  }


  private get showAvatar(): boolean {
    if (!this.tickAvailable) { return false }
    var settings = this.widgetSettings;

    return settings?.conversation?.showAvatars;
  }

  private get positionAllMessagesLeft(): boolean {
    if (!this.tickAvailable) { return false }
    var settings = this.widgetSettings;

    return settings?.conversation?.positionAllMessagesLeft;
  }

  private get useWidth(): boolean {
    if (!this.tickAvailable) { return false }
    var settings = this.widgetSettings;
    return settings.maxWidth != null;
  }



  private get useCustomMessageBoxPadding(): boolean {
    if (!this.tickAvailable) { return false; }
    var settings = this.widgetSettings;
    return settings.conversation?.messageBoxStyle?.useCustomPadding;
  }

  private get useCustomOpenerPadding(): boolean {
    if (!this.tickAvailable) { return false; }
    var settings = this.widgetSettings;
    return settings.opener?.styling?.useCustomPadding;
  }
  private get useCustomActionPadding(): boolean {
    if (!this.tickAvailable) { return false; }
    var settings = this.widgetSettings;
    return settings.conversation?.messageActions.useCustomPadding;
  }

  private get useCustomInboundMessagePadding(): boolean {
    if (!this.tickAvailable) { return false; }
    var settings = this.widgetSettings;
    return settings.conversation?.inboundMessageStyle?.useCustomPadding;
  }
  private get useCustomOutboundMessagePadding(): boolean {
    if (!this.tickAvailable) { return false; }
    var settings = this.widgetSettings;
    return settings.conversation?.outboundMessageStyle?.useCustomPadding;
  }

  private get useCustomHeaderPadding(): boolean {
    if (!this.tickAvailable) { return false; }
    var settings = this.widgetSettings;
    return settings.header?.useCustomPadding;
  }
  private get useCustomPadding(): boolean {
    if (!this.tickAvailable) { return false; }
    var settings = this.widgetSettings;
    return settings.styling?.useCustomPadding;
  }
  private get cssVars() {
    if (!this.tickAvailable) { return {} }
    var settings = this.widgetSettings;

    const defaultBackgroundImageUrl = "";
    const defaultFontFamily = "'Outfit', sans-serif"
    const defaultFontSize = 12;

    //console.log(settings);

    if (!settings || typeof (settings) != 'object') { settings = {} }
    if (!settings.maxHeightPercentage) { settings.maxHeightPercentage = 100 }
    if (!settings.opener) { settings.opener = {}; }
    if (!settings.lobby) { settings.lobby = {}; }
    if (!settings.conversation) { settings.conversation = {}; }

    const widgetFont = settings.styling?.fontFamily || defaultFontFamily;
    const widgetFontSize = settings.styling?.fontSize || defaultFontSize;

    const widgetStyle = generateStylingProperties("", settings.styling, widgetFont, widgetFontSize);
    const headerStyle = generateStylingProperties("header", settings.header, widgetFont, widgetFontSize);
    const openerStyle = generateStylingProperties("opener", settings.opener.styling, widgetFont, widgetFontSize);
    const lobbyActionsStyle = generateStylingProperties("lobby-actions", settings.lobby.actionsStyling, widgetFont, widgetFontSize);
    const conversationButton = generateStylingProperties("conversation-button", settings.conversation.buttonsStyle, widgetFont, widgetFontSize);
    const conversationMessageInbound = generateStylingProperties("conversation-message-inbound", settings.conversation.inboundMessageStyle, widgetFont, widgetFontSize);
    const conversationMessageOutbound = generateStylingProperties("conversation-message-outbound", settings.conversation.outboundMessageStyle, widgetFont, widgetFontSize);
    const conversationMessageActions = generateStylingProperties("conversation-message-actions", settings.conversation.messageActions, widgetFont, widgetFontSize);
    const conversationMessagebox = generateStylingProperties("conversation-messagebox", settings.conversation.messageBoxStyle, widgetFont, widgetFontSize);


    let openerPosRight = settings.opener?.styling?.useCustomPadding ? settings.opener?.styling?.padding_LeftTop + settings.opener?.styling?.padding_RightTop : 0;
    openerPosRight += 30;

    const generalStyles = {
      '--cw-mobile-font-size': '1em',
      '--cw-max-height': settings.maxHeightPercentage + 'dvh',
      '--cw-max-width': settings.maxWidth ? settings.maxWidth + 'px' : '',
      '--cw-bg-image': settings.styling.showBackground ? 'url(' + (settings.backgroundImageFileUrl || defaultBackgroundImageUrl) + ")" : "",
      '--cw-opener-bg-image': settings.opener.styling.showBackground ? 'url(' + (settings.opener.backgroundImageFileUrl || defaultBackgroundImageUrl) + ")" : "",
      '--cw-opener-pos-right': openerPosRight + 'px',
    }

    const allRules = { ...generalStyles, ...widgetStyle, ...headerStyle, ...openerStyle, ...lobbyActionsStyle, ...conversationButton, ...conversationMessageInbound, ...conversationMessageOutbound, ...conversationMessageActions, ...conversationMessagebox };

    return allRules;
  }

}
</script>

<style lang="scss">
@import "@/styles/theme";
@import "@/styles/fonts";
@import "@/styles/reset";
@import "@/styles/global";

@keyframes slide-in {
  0% {
    transform: translateY(110%) scale(0.1);
  }

  100% {
    transform: translateY(0%) scale(1);
  }
}

@keyframes slide-out {
  0% {
    transform: translateY(0%)scale(1);
  }

  100% {
    transform: translateY(500%)scale(0.1);
  }
}


.cw-widget-button-holder {
  font-family: var(--cw-opener-font-family);
  font-size: var(--cw-opener-font-size);
  font-style: normal;

  z-index: 9999999999;
  position: fixed;
  bottom: clamp(10px, 1vh, 100px);
  right: var(--cw-opener-pos-right);
  width: 60px;
  height: 60px;
  color: var(--cw-opener-fg-color);
  background: var(--cw-opener-bg-color);
  border-radius: var(--cw-opener-border-radius);
  border: solid var(--cw-opener-border-width) var(--cw-opener-border-color);
  box-shadow: var(--cw-opener-drop-shadow);
  box-sizing: border-box;

  &.showFullScreen {
    font-size: var(--cw-mobile-font-size);
    width: clamp(50px, 15vmin, 80px);
    height: clamp(50px, 15vmin, 80px);
    bottom: clamp(20px, 1vmin, 100px);
  }


  &.square {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: var(--cw-opener-bg-image);
    background-repeat: no-repeat;
    background-size: cover;
  }

  &.landscape {
    height: 40px;
    min-width: 90px;
    width: auto;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    padding: 0px 10px 0px 0px;
    overflow: hidden;

    .cw-icon {

      &.has-bg {
        height: 40px;
        width: 40px;
        background-image: var(--cw-opener-bg-image);
        background-repeat: no-repeat;
        background-size: cover;


      }
    }

    .cw-title {}

  }

  &.use-custom-padding {
    padding: var(--cw-opener-padding);
  }

  .cw-icon {
    color: var(--cw-opener-fg-color);
    display: inline-block;
  }

  .cw-title {
    color: var(--cw-opener-fg-color);
    display: inline-block;
    font-weight: 600;
    text-align: center;
  }

  transform: translateY(-100%);
  -webkit-transform: translateY(-100%);


  &.slide-in {
    animation: slide-in 0.2s forwards;
    -webkit-animation: slide-in 0.2s forwards;
  }

  &.slide-out {
    animation: slide-out 0.2s forwards;
    -webkit-animation: slide-out 0.2s forwards;
  }


}

.cw-widget-holder {
  overflow-x: hidden;
  //overflow-y: auto;
  font-family: var(--cw-font-family);
  font-size: var(--cw-font-size);
  font-style: normal;
  z-index: 999999999;
  position: fixed;
  bottom: 10px;
  right: 10px;
  color: var(--cw-fg-color);
  background: var(--cw-bg-color);
  border-radius: var(--cw-border-radius);
  box-shadow: var(--cw-drop-shadow);
  border: solid var(--cw-border-width) var(--cw-border-color);
  //transition: width 0.2s ease-in-out;
  width: clamp(300px, 20vw, 800px);
  background-image: var(--cw-bg-image);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
  transform: translateY(-100%);
  -webkit-transform: translateY(-100%);

  &.useWidth {
    width: clamp(300px, var(--cw-max-width), calc(var(--cw-max-width) - 40px));
  }


  &.slide-in {
    animation: slide-in 0.2s forwards;
    -webkit-animation: slide-in 0.2s forwards;
  }

  &.slide-out {
    animation: slide-out 0.2s forwards;
    -webkit-animation: slide-out 0.2s forwards;
  }

  &.showFullScreen {
    -webkit-text-size-adjust: none;
    width: 100%;
    height: 100dvh;
    max-height: 100%;
    min-height: 100%;
    right: 0px;
    border-radius: 0px;
    padding: 0px;
    font-size: 3.2vw;
    position: fixed;
    top: 0px;
    left: 0px;
    overflow: hidden;

    .cw-header-holder {
      .cw-header-toggle-notifications {
        height: clamp(10px, 6vw, 40px);
        width: clamp(10px, 6vw, 40px);

        svg {
          height: clamp(10px, 6vw, 40px);
          width: clamp(10px, 6vw, 40px);
        }

      }

      .cw-header-title {
        font-size: clamp(10px, var(--cw-mobile-font-size), 50px);
        height: clamp(10px, 6vw, 40px);
      }

      .cw-header-toggle-widget {
        height: clamp(10px, 6vw, 40px);
        width: clamp(10px, 6vw, 40px);

        svg {
          height: clamp(10px, 6vw, 40px);
          width: clamp(10px, 6vw, 40px);
        }

      }

    }

    .cw-widget-content {
      padding-bottom: clamp(10px, 9vh, 20px);

      height: calc(100% - 50px); // same as lobby
      max-height: 100%;

      .cw-general-button {
        width: clamp(20px, 9vw, 50px);
        height: clamp(20px, 9vw, 50px);
      }

      .cw-communication-holder {
        min-height: clamp(40px, 6vmin, 80px);
        padding: clamp(5px, 3vmin, 10px);

        .cw-actions-holder {
          //width: 9vw;
          height: clamp(20px, 9vw, 50px);
        }
      }

    }


  }




  .cw-header-holder {
    //box-sizing: border-box;
    width: 100%;
    padding: 10px 5px 5px 10px;
    display: flex;
    align-items: center;
    justify-items: center;
    //height: 40px;
    overflow: hidden;

    background: var(--cw-header-bg-color);
    color: var(--cw-header-fg-color);
    border-bottom: solid var(--cw-header-border-width) var(--cw-header-border-color);
    border-radius: var(--cw-header-border-radius);
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    box-shadow: var(--cw-header-drop-shadow);

    &.use-custom-padding {
      padding: var(--cw-header-padding);
    }

    .cw-header-toggle-notifications {
      display: flex;
      align-items: center;
      justify-items: left;
      height: 24px;
      width: 24px;
      text-align: left;

      &.on {
        opacity: 0.5;
      }

      svg {
        color: var(--cw-fg-color);
        color: var(--cw-header-fg-color);
        height: 20px;
        width: 20px;
      }

    }

    .cw-header-title {
      display: flex;
      align-items: center;
      justify-items: center;
      flex-grow: 1;
      height: 24px;
      justify-content: center;
      font-family: var(--cw-header-font-family);
      font-size: var(--cw-header-font-size);
    }

    .cw-header-toggle-widget {
      display: flex;
      align-items: center;
      justify-items: end;
      height: 20px;
      width: 20px;

      svg {
        color: var(--cw-fg-color);
        color: var(--cw-header-fg-color);
      }

    }


  }

  .preview-controller {
    padding: 20px;


  }

  .cw-uploads {
    height: 100%;
    padding: 10px;

    .cw-uploads-content {
      min-height: 400px;
      padding: 20px;

      .cw-uploads-clicker {
        text-decoration: underline;
      }

    }

  }

  .cw-widget-content {

    //min-height: 30vh;
    display: grid;
    grid-template-rows: 1fr auto;
    grid-template-columns: 100%;
    //padding-bottom: 20px;
    // transition: all 2s ease-in-out;
    max-height: calc(var(--cw-max-height) - 10vmin);

    &.use-custom-padding {
      padding: var(--cw-padding);
    }

    .cw-messaging-holder {
      width: 100%;
      padding: 10px;
      overflow-x: hidden;
      overflow-y: auto;
      display: flex;
      flex-direction: column-reverse;
      gap: 2px;

      .cw-message {
        margin-top: 5px;

        &.same-sender {
          margin-top: -14px;
        }

        // margin-bottom: 5px;
        // padding: 5px 0px;
        //margin: 5px;
      }


    }

    .cw-typingindicator-holder {
      padding-left: 10px;
      height: 10px;
    }

    .cw-communication-holder {
      min-height: 50px;
      display: flex;
      width: calc(100% - 20px);

      background: var(--cw-conversation-messagebox-bg-color);
      color: var(--cw-conversation-messagebox-fg-color);
      border: solid var(--cw-conversation-messagebox-border-width) var(--cw-conversation-messagebox-border-color);
      border-radius: var(--cw-conversation-messagebox-border-radius);
      font-family: var(--cw-conversation-messagebox-font-family);
      font-size: var(--cw-conversation-messagebox-font-size);
      box-shadow: var(--cw-conversation-messagebox-drop-shadow);

      margin: 10px;

      padding: 5px;


      &.use-custom-padding {
        padding: var(--cw-conversation-messagebox-padding);
      }

      gap: 5px;

      .cw-message-holder {
        flex-grow: 1;
        justify-content: center;
        //padding: 5px;


        .cw-message-draft-text {
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          //padding: 5%;
          padding-left: 10px;
        }

      }


      .cw-actions-holder {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        height: 40px; // same height as initial textbox
      }

    }
  }
}

.cw-general-button {
  padding: 5px;
  background: var(--cw-conversation-button-bg-color);
  color: var(--cw-conversation-button-fg-color);
  border: solid var(--cw-conversation-button-border-width) var(--cw-conversation-button-border-color);
  border-radius: var(--cw-conversation-button-border-radius);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  height: 30px;

  svg {
    width: 60%;
    height: 60%;
  }
}


/* For Mobile */
//Iphone disable zoom input
@media screen and (-webkit-min-device-pixel-ratio:0) {

  select,
  textarea,
  input {
    font-size: var(--cw-mobile-font-size);
  }
}

@media screen and (hover: none) and (orientation:portrait),
screen and (max-width: 800px) {
  // .cw-widget-button-holder {
  //   font-size: var(--cw-mobile-font-size);
  //   width: 15vmin;
  //   height: 15vmin;
  //   bottom: 20px;
  //   //right: 20px;
  // }

  // .cw-widget-holder {
  //   -webkit-text-size-adjust: none;

  //   width: 100% !important;
  //   height: 100dvh;
  //   max-height: 100%;
  //   min-height: 100%;
  //   right: 0px;
  //   border-radius: 0px;
  //   padding: 10px;

  //   font-size: 3.2vw;
  //   position: fixed;
  //   top: 0px;
  //   left: 0px;
  //   overflow: hidden;



  //   .cw-header-holder {

  //     .cw-header-toggle-notifications {
  //       height: 6vw;
  //       width: 6vw;

  //       svg {
  //         height: 6vw;
  //         width: 6vw;
  //       }

  //     }

  //     .cw-header-title {
  //       font-size: var(--cw-mobile-font-size);
  //       height: 6vw
  //     }

  //     .cw-header-toggle-widget {

  //       height: 6vw;
  //       width: 6vw;

  //       svg {
  //         height: 6vw;
  //         width: 6vw;
  //       }

  //     }

  //   }

  //   .cw-widget-content {
  //     padding-bottom: 3vh;

  //     height: calc(100% - 50px); // same as lobby
  //     max-height: 100%;

  //     .cw-general-button {
  //       width: 9vw;
  //       height: 9vw;
  //     }

  //     .cw-communication-holder {
  //       min-height: 12vw;
  //       padding-right: 1vw;
  //       padding: 3vw;

  //       .cw-actions-holder {
  //         //width: 9vw;
  //         height: 9vw;
  //       }
  //     }

  //   }

  // }



}
</style>